<template>
    <div class="content-wrapper control-room-listing">
        <!-- <div class="row align-items-end mb-3">
            <div class="col-sm-12 col-lg-7">
                <app-breadcrumb :page-title="$t('control_room')" :directory="$t('trackings')" :icon="'grid'" />
                <p class="control-room-listing__intro mb-0">
                    {{ $t('control_room_listing_hint') }}
                </p>
            </div>
        </div> -->
        <div class="d-flex justify-content-end flex-wrap mb-3">
            <a
                :href="listingModeUrl"
                class="btn btn-outline-primary btn-with-shadow mr-2 mb-2"
            >
                <app-icon name="list" class="size-18 mr-2" />
                {{ $t('listing_mode') }}
            </a>
            <button
                type="button"
                class="btn btn-with-shadow mr-2 mb-2"
                :class="liveTrackingOnly ? 'btn-success' : 'btn-outline-success'"
                @click="toggleLiveTrackingOnly"
            >
                <app-icon name="map-pin" class="size-18 mr-2" />
                {{ $t('live_tracking') }}
            </button>
            <button
                type="button"
                class="btn btn-outline-primary btn-with-shadow mb-2"
                :class="{ 'disabled': refreshing }"
                :disabled="refreshing"
                @click="refreshControlRoom"
            >
                <app-icon name="refresh-ccw" class="size-18 mr-2" :class="{ 'rotate-animation': refreshing }" />
                {{ $t('refresh_tracker_data') }}
            </button>
        </div>
        <app-table :id="tableId" :options="options" row-density="compact" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import AppFunction from '../../../../core/helpers/app/AppFunction';
import * as actions from '../../../Config/ApiUrl';
import moment from 'moment';
import { formatDateToLocal, timeInterval } from '../../../Helpers/Helpers';

export default {
    name: 'ControlAppTrips',
    extends: CoreLibrary,
    data() {
        return {
            tableId: 'control-trips-table',
            liveTrackingOnly: true,
            refreshing: false,
            autoRefreshTimer: null,
            options: {
                name: 'ControlRoomTrips',
                url: actions.TRIP_CONTROL_ROOM,
                showHeader: true,
                enableCookie: false,
                enableSaveFilter: true,
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: 'pagination',
                responsive: true,
                rowLimit: 20,
                paginationOptions: [20, 50, 100, 250],
                showAction: false,
                orderBy: 'desc',
                actionType: 'default',
                filters: [
                    {
                        title: this.$t('client'),
                        type: 'multi-select-filter',
                        key: 'clients',
                        option: [],
                        permission: true,
                    },
                    {
                        title: this.$t('site'),
                        type: 'multi-select-filter',
                        key: 'sites',
                        option: [],
                        permission: true,
                    },
                    {
                        title: this.$t('transporter'),
                        type: 'multi-select-filter',
                        key: 'transporters',
                        option: [],
                        permission: true,
                    },
                    {
                        title: this.$t('trip_status'),
                        type: 'multi-select-filter',
                        key: 'status',
                        option: [],
                        permission: true,
                    },
                    {
                        title: this.$t('convoy_assignment'),
                        type: 'drop-down-filter',
                        key: 'convoy_assignment',
                        option: [
                            { id: 'in_convoy', value: this.$t('in_convoy') },
                            { id: 'solo', value: this.$t('solo') },
                        ],
                    },
                ],
                columns: [
                    {
                        title: this.$t('live_tracking'),
                        type: 'component',
                        key: 'active_device_name',
                        componentName: 'trip-device-cell',
                    },
                    {
                        title: this.$t('convoy_id'),
                        type: 'custom-html',
                        key: 'convoy_code',
                        sortable: true,
                        modifier: (value, row) => this.renderConvoyCell(row),
                    },
                    {
                        title: this.$t('horse_number'),
                        type: 'text',
                        key: 'horse',
                        sortable: true,
                    },
                    {
                        title: this.$t('speed'),
                        type: 'custom-html',
                        key: 'control_speed',
                        modifier: (value, row) => this.renderSpeedCell(row),
                    },
                    {
                        title: this.$t('relative_distance'),
                        type: 'custom-html',
                        key: 'relative_distance_km',
                        modifier: (value, row) => this.renderRelativeDistanceCell(row),
                    },
                    {
                        title: this.$t('transporter'),
                        type: 'text',
                        key: 'transporter_name',
                        sortable: true,
                    },
                    {
                        title: this.$t('battery_level'),
                        type: 'custom-html',
                        key: 'tracker_battery_level',
                        modifier: (value, row) => this.renderBatteryCell(row),
                    },
                    {
                        title: this.$t('tracker_status'),
                        type: 'custom-html',
                        key: 'tracker_status_state',
                        modifier: (value, row) => this.renderTrackerStatusCell(row),
                    },
                    {
                        title: this.$t('last_alert'),
                        type: 'component',
                        key: 'last_alert_label',
                        componentName: 'control-room-alert-cell',
                        isVisible: true,
                    },
                    {
                        title: this.$t('stop_time'),
                        type: 'custom-html',
                        key: 'stop_started_at',
                        modifier: (value, row) => this.renderStopTimeCell(row),
                    },
                    {
                        title: this.$t('truck_status'),
                        type: 'custom-html',
                        key: 'status_name',
                        sortable: true,
                        modifier: (value, row) => this.renderTruckStatusCell(row),
                    },
                ],
            },
        };
    },
    computed: {
        listingModeUrl() {
            return AppFunction.getAppUrl('app-trackings');
        },
        isClientScopedUser() {
            return Boolean(this.$store.state.clientScope?.isClientScoped);
        },
        clients() {
            return this.$store.getters.getClientTrip.map((client) => ({
                id: client.id,
                value: client.name,
            }));
        },
        sites() {
            return this.$store.getters.getSiteTrip.map((site) => ({
                id: site.id,
                value: site.name,
            }));
        },
        transporters() {
            return this.$store.getters.getTransporterTrip.map((transporter) => ({
                id: transporter.id,
                value: transporter.name,
            }));
        },
        tripStatuses() {
            return this.$store.getters.getStatusTrip.map((status) => ({
                id: status.id,
                value: status.name,
            }));
        },
    },
    watch: {
        isClientScopedUser: {
            handler(isClientScoped) {
                const alertColumn = this.options.columns.find((column) => column.key === 'last_alert_label');

                if (alertColumn) {
                    alertColumn.isVisible = !isClientScoped;
                }
            },
            immediate: true,
        },
        'clients.length': {
            handler() {
                this.syncFilterOptions('clients', this.clients);
            },
            immediate: true,
        },
        'sites.length': {
            handler() {
                this.syncFilterOptions('sites', this.sites);
            },
            immediate: true,
        },
        'transporters.length': {
            handler() {
                this.syncFilterOptions('transporters', this.transporters);
            },
            immediate: true,
        },
        'tripStatuses.length': {
            handler() {
                this.syncFilterOptions('status', this.tripStatuses);
            },
            immediate: true,
        },
    },
    mounted() {
        this.$store.dispatch('getClients');
        this.$store.dispatch('getSites');
        this.$store.dispatch('getTransporters');
        this.$store.dispatch('getStatus');
        this.autoRefreshTimer = window.setInterval(() => this.refreshControlRoom(), 60000);
    },
    beforeDestroy() {
        if (this.autoRefreshTimer) {
            window.clearInterval(this.autoRefreshTimer);
        }
    },
    methods: {
        toggleLiveTrackingOnly() {
            this.liveTrackingOnly = !this.liveTrackingOnly;
            this.options.url = this.buildControlRoomUrl();
            this.$hub.$emit(`reload-${this.tableId}`);
        },
        refreshControlRoom() {
            this.refreshing = true;
            this.options.url = this.buildControlRoomUrl(Date.now());
            this.$hub.$emit(`reload-${this.tableId}`, false);

            window.setTimeout(() => {
                this.refreshing = false;
            }, 900);
        },
        buildControlRoomUrl(refreshAt = null) {
            const params = ['control_room=1'];

            if (this.liveTrackingOnly) {
                params.push('device_assignment=assigned');
            }

            if (refreshAt) {
                params.push(`refresh_at=${refreshAt}`);
            }

            return `${actions.TRIP}?${params.join('&')}`;
        },
        syncFilterOptions(key, entries) {
            const filter = this.options.filters.find((item) => item.key === key);

            if (filter) {
                filter.option = [...entries];
            }
        },
        renderConvoyCell(row) {
            if (!row.convoy_identifier) {
                return '<span class="text-muted">---</span>';
            }

            const fullIdentifier = String(row.convoy_identifier);
            const compactIdentifier = this.formatConvoyIdentifier(fullIdentifier);

            return `<span class="badge badge-pill badge-dark" title="${this.escapeHtml(fullIdentifier)}">${this.escapeHtml(compactIdentifier)}</span>`;
        },
        renderSpeedCell(row) {
            if (row.active_device_id && !row.tracker_live_available) {
                return `<span class="text-warning font-weight-bold">${this.$t('live_data_unavailable')}</span>`;
            }

            const value = row.control_speed;
            const speedLabel = value === 0 || value ? `${value} km/h` : '---';
            const recordedAtLabel = row.tracker_recorded_at
                ? this.formatPajTimestamp(row.tracker_recorded_at)
                : null;

            return `
                <div class="control-room-listing__stack">
                    <strong>${speedLabel}</strong>
                    ${recordedAtLabel ? `<small class="text-muted">${this.$t('recorded_at')} ${recordedAtLabel}</small>` : ''}
                </div>
            `;
        },
        renderRelativeDistanceCell(row) {
            if (!row.convoy_id) {
                return '<span class="text-muted">---</span>';
            }

            if (row.convoy_role === 'master') {
                return `<span class="badge badge-pill badge-success">${this.$t('lead_truck')}</span>`;
            }

            if (row.relative_distance_km === 0 || row.relative_distance_km) {
                return `<strong>${row.relative_distance_km} km</strong>`;
            }

            return '<span class="text-muted">---</span>';
        },
        renderBatteryCell(row) {
            const batteryLevel = row.tracker_battery_level;

            if (batteryLevel !== 0 && !batteryLevel) {
                return '<span class="text-muted">---</span>';
            }

            let badgeClass = 'badge-success';

            if (batteryLevel <= 20) {
                badgeClass = 'badge-danger';
            } else if (batteryLevel <= 50) {
                badgeClass = 'badge-warning';
            }

            return `<span class="badge badge-pill ${badgeClass}">${batteryLevel}%</span>`;
        },
        renderTrackerStatusCell(row) {
            const badgeClass = {
                active_direct: 'badge-success',
                removed: 'badge-warning',
                not_assigned: 'badge-secondary',
            }[row.tracker_status_state] || 'badge-secondary';

            const dateLabel = row.tracker_status_at
                ? this.formatControlTimestamp(row.tracker_status_at)
                : null;

            let text = this.$t('tracker_not_assigned');

            if (row.tracker_status_state === 'active_direct') {
                text = dateLabel
                    ? `${this.$t('tracker_placed_on')} ${dateLabel}`
                    : this.$t('assigned');
            } else if (row.tracker_status_state === 'removed') {
                text = dateLabel
                    ? `${this.$t('tracker_removed_on')} ${dateLabel}`
                    : this.$t('unassigned');
            }

            return `<span class="badge badge-pill ${badgeClass} control-room-listing__status-pill">${text}</span>`;
        },
        renderStopTimeCell(row) {
            if (!row.active_device_id) {
                return '<span class="text-muted">---</span>';
            }

            if (row.control_speed > 0) {
                return `<span class="badge badge-pill badge-success">${this.$t('moving')}</span>`;
            }

            if (!row.stop_started_at) {
                return '<span class="text-muted">---</span>';
            }

            return `
                <div class="control-room-listing__stack">
                    <strong>${timeInterval(row.stop_started_at)}</strong>
                    <small class="text-muted">${this.formatControlTimestamp(row.stop_started_at)}</small>
                </div>
            `;
        },
        renderTruckStatusCell(row) {
            if (!row.truck_status_label) {
                return '<span class="text-muted">---</span>';
            }

            return `<span class="badge badge-${row.truck_status_type || 'secondary'} badge-pill">${row.truck_status_label}</span>`;
        },
        formatConvoyIdentifier(identifier) {
            if (identifier.length <= 12) {
                return identifier;
            }

            return `${identifier.slice(0, 4)}...${identifier.slice(-4)}`;
        },
        escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        },
        formatControlTimestamp(value) {
            return formatDateToLocal(value, true);
        },
        formatPajTimestamp(value) {
            const dateFormatMap = {
                'd-m-Y': 'DD-MM-YYYY',
                'm-d-Y': 'MM-DD-YYYY',
                'Y-m-d': 'YYYY-MM-DD',
                'm/d/Y': 'MM/DD/YYYY',
                'd/m/Y': 'DD/MM/YYYY',
                'Y/m/d': 'YYYY/MM/DD',
                'm.d.Y': 'MM.DD.YYYY',
                'd.m.Y': 'DD.MM.YYYY',
                'Y.m.d': 'YYYY.MM.DD',
            };
            const dateFormat = dateFormatMap[window.settings?.date_format] || 'DD-MM-YYYY';
            const timeFormat = `${window.settings?.time_format || 'H'}:mm:ss`;

            return moment.utc(value).format(`${dateFormat} ${timeFormat}`);
        },
    },
};
</script>

<style scoped>
.control-room-listing__intro {
    max-width: 48rem;
    color: #6b7b93;
}

.control-room-listing__stack {
    display: grid;
    gap: 0.1rem;
}

.control-room-listing__status-pill {
    white-space: normal;
    text-align: left;
    line-height: 1.35;
}

.rotate-animation {
    animation: control-room-spin 0.85s linear infinite;
}

@keyframes control-room-spin {
    to { transform: rotate(360deg); }
}
</style>
